// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\home\\SupportSection\\index.ts"
);
import.meta.hot.lastModified = "1757171103323.9631";
}
// REMIX HMR END

export { SupportSection } from "./SupportSection";
export type { SupportItem } from "./SupportSection";